import React from 'react';
import {Button} from "./Button";
import InputRange from 'react-input-range';
import {connect} from "react-redux";
import packages from "../collections/packages"
import {setTemplate, setGrade} from "../redux/actions";
import TextBlock from "./textblock";
import 'react-input-range/lib/css/index.css';

class packagePicker extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            grade : "" ,
            currentStepIndex : 0,
            value: 0,

        };
        this.packageData = this.packageData.bind ( this );
        this.handleTemplate = this.handleTemplate.bind ( this );
        this.handleInputChange=this.handleInputChange.bind(this)
    }

    handleTemplate = (param) => {
        let grade = !!this.state.grade ? this.state.grade : " ";
        let data;
        data = !!param?param:15;
        let properties = packages[grade][data].template;
        this.props.setTemplate (
            {
                template : properties ,
                product : packages[grade][data].product
            }, ()=>{}
        );
    };

    packageData(param) {
        let grade = !!this.state.grade ? this.state.grade : " ";
        let data;
        data = param;
        let properties = packages[grade][data];
        let array = [];
        for (let property in properties) {
            if (property !== "template" && property !== "product") {
                array.push ( <div className={"data-field"}>
                    <div className={"data-header"}>{property}</div>
                    <div className={"data-item"}>{properties[property]}</div>
                </div> )
            }
        }
        return array;
    }

    premiumPick = (chosenPackage) => {
        this.setState ( { grade : chosenPackage } );
    };

    handleInputChange = e => {
        this.setState ( { currentStepIndex : e.currentTarget.value } );
    };

    render() {
        let values = () => {
            let array = [];
            for (let premium in packages[this.state.grade]) {
                array.push ( premium )
            }
            return array
        };

        return (
            <div className={"flex-center grow-1 wrap column"}>
                <div>
                    <div id={"landing"}>
                    <TextBlock className={"text-box-grey"}
                        text={"Osiguranje djece i omladine od posljedica nezgode nikad nije bilo lakše, u par\n" +
                        "jednostavnih koraka izaberite koliko želite da iznosi cijena (premija) osiguranja\n" +
                        "popunite ostale podatke i dobićete polisu osiguranja na Vaš mail."}/>
                    </div>
                </div>
                <div>Kupi osiguranje:</div>
                <div className={"flex-center wrap"}>
                    <Button
                        text={"Vrtić/Osnovna škola"}
                        class={"button-regular margin-20 " + (this.state.grade === "osnovna" ? " active-button" : "")}
                        onClick={() => {
                            this.premiumPick ( "osnovna" ); this.props.setGrade ( { grade : "osnovna"}, );
                            this.setState({value: 0, currentStepIndex : 0 }, ()=>{});
                            this.forceUpdate();
                            this.props.setTemplate (
                                {
                                    template : 1521600 ,
                                    product : "Vrtić i osnovci 5€"
                                }, ()=>{}
                            );
                        }}/>
                    <Button
                        text={"Student/Srednja škola"}
                        class={"button-regular margin-20" + (this.state.grade === "srednja" ? " active-button" : "")}
                        onClick={() => {
                            this.premiumPick ( "srednja" ); this.props.setGrade ( { grade : "srednja" } );
                            this.props.setTemplate (
                                {
                                    template : 1499740 ,
                                    product : "Srednjoškolci i studenti 5€"
                                }, ()=>{}
                            );
                        }}/>
                </div>
                {this.state.grade &&
                <div className={"flex-center wrap w-100"}>
                    <div>Izaberite iznos godišnje premije</div>
                    <InputRange
                        formatLabel={value => values()[value]+"€"}
                        maxValue={values().length-1}
                        minValue={0}
                        value={this.state.value}
                        onChange={value => {
                            this.setState({ value });
                            this.setState({ currentStepIndex : value });
                            this.handleTemplate ( values ()[this.state.currentStepIndex] )
                        }} />

                    <div id={"tabular-data"}>
                        {this.packageData ( values ()[this.state.currentStepIndex] )}
                    </div>
                    {this.state.grade &&
                    <Button
                        text={"Izabrana premija: " + values ()[this.state.currentStepIndex] + " €. Nastavi >"}
                        class={"button-regular margin-20"}
                        onClick={this.props.handlePick}/>}
                </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
        insuranceType : state ? state.insuranceType : '' ,
    });
};
const mapDispatchToProps = (dispatch) => {
    return ({
        setTemplate : (params) => {
            dispatch ( setTemplate ( params ) );
        } ,
        setGrade : (params) => {
            dispatch ( setGrade ( params ) );
        }

    }
)
};
export const PackagePicker = connect ( mapStateToProps , mapDispatchToProps ) ( packagePicker );

